import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_4f1f7699: FaireBrandEntity = {
  token: "b_4f1f7699",
  type: "brand",
  name: "Anchal",
  avatarUrl: "https://cdn.faire.com/fastly/59538353163e3557fc7adc0e34ddfc23fde71f98015dc6b65de9f4eaff3583d0.png",
  bannerUrl: "https://cdn.faire.com/fastly/c9e155ac78732ec0b1788483eb239c91a1399f69153f66a39083535d6e75fa52.jpeg",
  logoUrl: "https://cdn.faire.com/fastly/59538353163e3557fc7adc0e34ddfc23fde71f98015dc6b65de9f4eaff3583d0.png",
  heroImageUrl: "https://cdn.faire.com/fastly/c9e155ac78732ec0b1788483eb239c91a1399f69153f66a39083535d6e75fa52.jpeg",
  location: "Louisville, KY, USA",
  minimumOrderDollars: 300,
  rating: 5,
  reviewCount: 52,
  isTopShop: true,
  isInsider: true,
  description: "Anchal is a non-profit social enterprise that empowers marginalized women in India by creating sustainable, income-generating careers in eco-friendly textiles. Through collaboration and design, Anchal produces award-winning, handmade products that blend traditional techniques with eco-friendly methods, minimizing environmental impact and championing sustainability in the fashion industry.\n\nLed by sisters Colleen and Maggie Clines, Anchal’s contemporary designs are inspired by heritage artwork, vernacular architecture, and the maker's journey. The brand’s dynamic patchwork and unique stitch patterns innovate traditional Kantha quilting, with each piece meticulously hand-stitched by 180 artisans in Ajmer, India, using organic cotton or vintage sari fabric. Anchal’s mission provides its artisans with full-time jobs, healthcare, design training, and educational workshops, offering immediate, life-changing support with every purchase.",
  meta: {
    source: "api",
    importedAt: "2026-10-14T17:08:02.126Z",
    importedBy: "entity-db-cli"
  }
};
